import { KeycloakService } from '@elotech/components';

export default KeycloakService;
